import { defineAction } from '~/prix'
import healthUnitFetchAction from './healthUnitFetch.action.json' with { type: 'json' }
import { latitude, longitude, multiPolygon, polygon } from '~/prix/types/presets/geo'
import { z } from 'zod'

const polygonOrMultiPolygon = z.union([polygon(), multiPolygon()])
const intersection = polygonOrMultiPolygon.superRefine((geometry, context) => {
  const issue = (message: string) => {
    context.addIssue({
      code: z.ZodIssueCode.custom,
      message,
    })
  }

  if (geometry.type === 'Polygon') {
    if (geometry.coordinates.length === 0) {
      issue('Poligono invalido. Forneca ao menos um anel.')
      return
    }

    const outerRing = geometry.coordinates[0]
    if (outerRing.length < 4) {
      issue('Poligono invalido. O anel externo deve ter pelo menos 4 pontos.')
      return
    }

    const first = outerRing[0]
    const last = outerRing[outerRing.length - 1]
    if (first[0] !== last[0] || first[1] !== last[1]) {
      issue('Poligono invalido. O anel externo deve ser fechado.')
    }
    return
  }

  if (geometry.coordinates.length === 0) {
    issue('Multipoligono invalido. Forneca ao menos um poligono.')
    return
  }

  for (const polygonCoordinates of geometry.coordinates) {
    if (polygonCoordinates.length === 0) {
      issue('Multipoligono invalido. Forneca ao menos um anel em cada poligono.')
      return
    }

    const outerRing = polygonCoordinates[0]
    if (outerRing.length < 4) {
      issue('Multipoligono invalido. O anel externo deve ter pelo menos 4 pontos.')
      return
    }

    const first = outerRing[0]
    const last = outerRing[outerRing.length - 1]
    if (first[0] !== last[0] || first[1] !== last[1]) {
      issue('Multipoligono invalido. O anel externo deve ser fechado.')
      return
    }
  }
})
const coverageAreaKind = z.enum([
  'smartMapping',
  'deprecated',
  'manualDrawing',
  'authorityProvided',
  'openStreetMapSourced',
])

const healthUnitFetchDefinition = defineAction({
  ...healthUnitFetchAction,

  input: z.object({
    intersection,
    municipalityId: z.number().nullish(),
  }),
  output: z.object({
    items: z.array(
      z.object({
        key: z.string(),
        cnes: z.string(),
        name: z.string(),
        kind: coverageAreaKind.nullish(),
        latitude: latitude().nullish(),
        longitude: longitude().nullish(),
        coverageArea: polygonOrMultiPolygon.nullish(),
      }),
    ),
  }),
})

export default healthUnitFetchDefinition
